import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ParishMark, Field, inputCls } from "../components/common";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function StaffLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", totp: "" });
  const [mfa, setMfa] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { ...f, totp: f.totp || null });
      login(r.data.token, r.data.user);
      nav(r.data.user.role === "monitor" ? "/monitor" : "/admin");
    } catch (er) {
      const m = errMsg(er);
      if (m === "MFA_REQUIRED") setMfa(true);
      else toast.error(m);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="hidden lg:flex flex-col justify-between bg-[#2D3B2D] text-[#FDFBF7] p-12 grain">
        <Link to="/" className="font-serif text-xl font-bold">SFAP-AMIS</Link>
        <div>
          <p className="font-serif text-4xl font-black leading-tight">Saint Francis of Assisi Parish</p>
          <p className="mt-2 text-sm uppercase tracking-[0.2em] text-[#E5DEC9]">Attendance Management Information System</p>
          <p className="mt-8 max-w-md text-[#E5DEC9]/90 leading-relaxed">Secure access for the Parish Administrator, attendance officers and authorized read-only monitors. Every administrative change is recorded in the audit history.</p>
        </div>
        <p className="text-xs text-[#E5DEC9]/70">Barangay Mabuhay, General Santos City · Diocese of Marbel</p>
      </div>
      <div className="flex flex-col justify-center px-6 py-12 sm:px-16">
        <div className="lg:hidden mb-8"><ParishMark /></div>
        <h1 className="font-serif text-3xl font-bold text-[#2D3B2D]">Staff sign in</h1>
        <p className="text-stone-600 mt-1 mb-8">Administrator, Attendance Officer or Authorized Monitor</p>
        <form onSubmit={submit} className="grid gap-5 max-w-md">
          <Field label="Email"><input className={inputCls} type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email" /></Field>
          <Field label="Password"><input className={inputCls} type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password" /></Field>
          {mfa && (
            <Field label="Authenticator code" hint="Open your authenticator app and enter the 6-digit SFAP-AMIS code.">
              <input className={`${inputCls} tracking-[0.4em] font-mono`} inputMode="numeric" maxLength={6} autoFocus value={f.totp} onChange={(e) => setF({ ...f, totp: e.target.value })} data-testid="login-totp" />
            </Field>
          )}
          <button className="btn-big btn-primary" disabled={busy} data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</button>
          <Link to="/" className="text-sm text-stone-500 hover:text-stone-800">← Back to parish attendance home</Link>
        </form>
      </div>
    </div>
  );
}
